// @flow
import React from 'react';
import classnames from 'classnames';

import { isLongFormat } from 'Components/utils/price/price.util';

import { themes } from './PriceItem.themes';

export type PriceItemProps = {
  className?: string,
  formattedValue?: string,
  label?: string,
  theme?: string,
  type?: 'best' | 'initial',
  value?: number,
  isValueClickable?: boolean,
};

export function PriceItem(props: PriceItemProps) {
  const {
    className,
    formattedValue,
    label,
    theme = 'package',
    type = 'best',
    value = 0,
    isValueClickable = false,
  } = props;

  if (!value || !formattedValue) return null;

  const classes = classnames(className, themes[type][theme].root);
  const valueClasses = isLongFormat(value)
    ? themes[type][theme].longValue
    : themes[type][theme].value;

  return (
    <span className={classes}>
      {!!label && (
        <span className={themes[type][theme].label} data-testid="PriceItem-label">
          {label}
        </span>
      )}
      {!!label && !!formattedValue && <span> </span>}
      <span
        className={classnames(valueClasses, { 'underline cursor-pointer': isValueClickable })}
        data-testid="PriceItem-value"
      >
        {formattedValue}
      </span>
    </span>
  );
}
